import { AuthUserRole } from "../../models/ResponseModels/AuthUserResponse";

export const isOwner = (role?: AuthUserRole | null) => {
  return role === "owner";
};

export const isManager = (role?: AuthUserRole | null) => {
  return role === "manager";
};

export const isCleaner = (role?: AuthUserRole | null) => {
  return role === "cleaner";
};

export const isViewer = (role?: AuthUserRole | null) => {
  return role === "viewer";
};

export const canManageBilling = (role?: AuthUserRole | null) => {
  return isOwner(role);
};

export const canManageOperations = (role?: AuthUserRole | null) => {
  return isOwner(role) || isManager(role);
};

export const canManageTeamMembers = (role?: AuthUserRole | null) => {
  return isOwner(role) || isManager(role);
};

export const canViewInvoices = (role?: AuthUserRole | null) => {
  return isOwner(role) || isManager(role);
};

export const canViewCleaningTasks = (role?: AuthUserRole | null) => {
  return isOwner(role) || isManager(role) || isCleaner(role);
};

export const canViewCalendar = (role?: AuthUserRole | null) => {
  return isOwner(role) || isManager(role) || isViewer(role);
};

export const getRoleTranslationKey = (role?: AuthUserRole | string | null) => {
  switch (role) {
    case "owner":
      return "roles.owner";
    case "manager":
      return "roles.manager";
    case "cleaner":
      return "roles.cleaner";
    case "viewer":
      return "roles.viewer";
    default:
      return "roles.teamMember";
  }
};

export const getRoleLabel = (role?: AuthUserRole | string | null) => {
  switch (role) {
    case "owner":
      return "Owner";
    case "manager":
      return "Manager";
    case "cleaner":
      return "Housekeeper";
    case "viewer":
      return "Viewer";
    default:
      return "Team member";
  }
};
